import { FC } from 'react';
import { useIntl } from 'react-intl';

import { PageTitle } from '../../../_metronic/layout/core';
import { LeadDistributorReport } from '../../modules/lead-distributors';
import TopSalesReport from '../../modules/dashboard/components/TopSalesReport';
import ReferencesReport from '../../modules/dashboard/components/ReferencesReport';
import PnLReport from '../../modules/dashboard/components/PnLReport';
import B2BSalesReport from '../../modules/b2b-orders/components/B2BSalesReport';

const B2BReportPage: FC = () => {
  const intl = useIntl();

  return (
    <>
      <PageTitle breadcrumbs={[]}>
        {intl.formatMessage({ id: 'leadDistributorReport.title' })}
      </PageTitle>
      <div className="row gy-4">
        <div className="card p-10">
          <PnLReport />
        </div>
        <div className="card p-10">
          <TopSalesReport />
        </div>
        <div className="card p-10">
          <ReferencesReport />
        </div>
        <div className="card p-10">
          <LeadDistributorReport />
        </div>
        <div className="card p-10">
          <B2BSalesReport />
        </div>
      </div>
    </>
  );
};

export { B2BReportPage };
